// Hooks
import { useAppDispatch } from '../../../app/hooks';

// Features
import { clearModalContent } from '../../../features/app/appSlice';
import { getAccessTokenAsync } from '../../../features/user/userSlice';

// Components
import Button from '../../atoms/Button/Button';
import ModalContent from './ModalContent';

/**
 * @function ModalContentTokenPurchase
 * Describe the ModalContentTokenPurchase's function
 *
 * @example
 * return (
 *   <ModalContentTokenPurchase />
 * )
 */
function ModalContentTokenPurchase(): JSX.Element {
    const dispatch = useAppDispatch();

    function handleSubmitClick() {
        dispatch(getAccessTokenAsync());
    }

    function handleCloseClick() {
        dispatch(clearModalContent());
    }

    return (
        <ModalContent>
            <>
                <h2>
                    Want to buy an <b>Access Token</b>?
                </h2>
                <p>
                    Buy <b>1</b> Access Token for <b>5,000 pp</b>
                </p>
                <Button
                    text="Yes confirm"
                    style="primary"
                    onClick={() => handleSubmitClick()}
                />
                <Button
                    text="No, cancel"
                    style="primary"
                    onClick={() => handleCloseClick()}
                />
            </>
        </ModalContent>
    );
}

// Exports
export default ModalContentTokenPurchase;
